import { Card } from "@/components/ui/card";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import GuestRow from "@/components/v2/molecules/admin/tabs/AdminGuestsTab/GuestRow";
import { type Guest } from "@/hooks/useGuests";

interface GuestsTableProps {
  guests: Guest[];
  canEdit: boolean;
  canDelete: boolean;
  onEdit: (guest: Guest) => void;
  onDelete: (guest: Guest) => void;
}

const GuestsTable = ({
  guests,
  onEdit,
  onDelete,
  canEdit,
  canDelete,
}: GuestsTableProps) => {
  const tableHeaders = ["Nombre", "Correo", "Teléfono", "Origen", "Acciones"];

  return (
    <Card>
      <div className="overflow-auto">
        <Table>
          <TableHeader>
            <TableRow>
              {tableHeaders.map((header) => (
                <TableHead key={header}>{header}</TableHead>
              ))}
            </TableRow>
          </TableHeader>

          <TableBody>
            {guests && guests.length > 0 ? (
              guests.map((guest) => (
                <GuestRow
                  key={guest.id}
                  guest={guest}
                  canEdit={canEdit}
                  canDelete={canDelete}
                  onEdit={onEdit}
                  onDelete={onDelete}
                />
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={12}
                  className="text-center py-8 text-muted-foreground"
                >
                  No hay huéspedes registrados
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
};

export default GuestsTable;
